import React from 'react';
import { Button, makeStyles, withStyles } from '@material-ui/core';

import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { isSurroundingsModeActive } from '../../Reducers/App/Selectors';
import { useDispatch, useSelector } from 'react-redux';
import { canAddMoreMachines, getSelectedInstanceId } from '../../Reducers/MachineInstance/Selectors';
import { addInstance, removeInstance } from '../../Reducers/MachineInstance/Actions';

const useStyles = makeStyles({
  root: {
    zIndex: 1,
    position: 'absolute',
    right: 32,
    top: 32,
    display: 'flex',
    gap: 16,
  },
});

const StyledButton = withStyles({
  root: {
    border: 0,
    fontSize: '1em',
    padding: '8px 16px',
  },
  label: {
    padding: 0,
  },
})(Button);

export const VisualizationTools = () => {
  const classes = useStyles();
  const isPlacementActive = useSelector(isSurroundingsModeActive);
  const isAddDisabled = !useSelector(canAddMoreMachines);
  const selectedId = useSelector(getSelectedInstanceId);
  const dispatch = useDispatch();
  const isRemoveDisabled = selectedId === null;

  return (
    <div className={classes.root}>
      {isPlacementActive && (
        <>
          <StyledButton disabled={isRemoveDisabled} onClick={() => dispatch(removeInstance(selectedId))}>
            {t('visualizationTools.removeMachine')}
          </StyledButton>
          <StyledButton disabled={isAddDisabled} onClick={() => dispatch(addInstance())}>
            {t('visualizationTools.addMachine')}
          </StyledButton>
        </>
      )}
      <StyledButton onClick={() => Services.visualization.resetCurrentView()}>
        {t('visualizationTools.resetCamera')}
      </StyledButton>
    </div>
  );
};

export default VisualizationTools;
